import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useBusinessTransaction({
  page = 1,
  perPage = 10,
  search = '',
  enabled = true,
  created_at = '',
}: {
  page?: number;
  perPage?: number;
  search?: string;
  enabled?: boolean;
  created_at?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['business-merchant/report/transaction', search, page, created_at], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'business-merchant/report/transaction',
        params: { page, per_page: perPage, search, created_at },
      });
      return res;
    },
    enabled,
    retry: false,
  });
}
